import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { VisualizadorPdfComponentDialog } from '../visualizador-pdf-dialog/visualizador-pdf-dialog.component';
import { PlanProtectionService } from '../../../app/service/plan-protection/plan-protection.service';


@Component({
  selector: 'app-nuevo-plan-protection-dialog',
  templateUrl: './nuevo-plan-protection-dialog.component.html',
  styleUrl: './nuevo-plan-protection-dialog.component.scss'
})
export class NuevoPlanProtectionDialogComponent {

  step = 1
  proveedorForm: FormGroup
  model
  editMode = true
  errorValidarCorreo = false
  headerTitle = 'Datos de Proveedor'
  gallery = {
    group1: true,
    group2: false,
    group3: false,
    group4: false
  };
  planProtection: any
  marcas = []
  years = []
  modelos = []
  yearDisabled = true
  modelDisabled = true
  auto = {
    marca: 'Selecciona una marca',
    marca_slug: '',
    logo: '',
    year: '',
    modelo: ''
  }

  show(groupName) {
    this.gallery.group1 = (groupName == 'group1') ? true : false;
    this.gallery.group2 = (groupName == 'group2') ? true : false;
    this.gallery.group3 = (groupName == 'group3') ? true : false;
  }
  constructor( 
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) 
    public data: any, 
    private ppService: PlanProtectionService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<NuevoPlanProtectionDialogComponent>) {
      this.proveedorForm = this.fb.group({
        folio: [{value: '', disabled: false}, [Validators.required]],
        empresa: [{value: '', disabled: false}, [Validators.required]],
        sucursal: [{value: '', disabled: false}, Validators.required],
        ordenVenta: [{value: '', disabled: false}, [Validators.required]],
        fechaContratado: [{value: '', disabled: false}, [Validators.required]],
        fechaVigencia: [{value: '', disabled: false}, [Validators.required]],
        nombreCliente: [{value: '', disabled: false}, [Validators.required]],
        apellidosCliente: [{value: '', disabled: false}, [Validators.required]],
        correoCliente: [{value: '', disabled: false}, [Validators.required]],
        celularCliente: [{value: '', disabled: false}, [Validators.required]],
        marca: [{value: '', disabled: false}, [Validators.required]],
        modelo: [{value: '', disabled: false}, [Validators.required]],
        ano: [{value: '', disabled: false}, [Validators.required]],
        kilometraje: [{value: '', disabled: false}, [Validators.required]],
        placas: [{value: '', disabled: false}, [Validators.required]],
        noSerie: [{value: '', disabled: false}, [Validators.required]],
        filtro: new FormControl('')
      })
  }

  ngOnInit() {
    this.getMarcas()
  }

  getMarcas(){
    this.ppService.getMarcas().subscribe(
      data => {
        this.marcas = data.data
      }
    )
  }

  validateStep(opc){
    this.step ++
  }

  
  nextStep(opc){
    opc === 1 ? this.step ++ : this.step --
  }

  async guardarProveedor(){

  }

  enviarArchivo(opc){
    
  }

  closeDialog(){
    this.dialogRef.close({event: 2})
  }

  onFileSelected(event: any, opc): void {
    const file: File = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      this.previewPDF(file, opc, event);
    } else {
      alert('Por favor selecciona un archivo PDF');
    }
  }

  previewPDF(file: File, opc, $event): void {
   
  }

  onSignature(dataUrl: string): void {
  }

  onImage(image: string): void {
  }

  abrirPdf(){
    const dialogRef = this.dialog.open(VisualizadorPdfComponentDialog, {
      panelClass: 'custom-dialog',
      disableClose: true,
      width: '100vw',
      height: '90vh',
      maxHeight: '720px',
      data: {
      }
    });
  }

  setCampoAuto(campo, valor, slug, logo){
    if(campo === 'marca'){
      this.auto.marca = valor
      this.auto.logo = logo
      this.auto.marca_slug = slug
      this.proveedorForm[campo] = valor
      this.getModelo()
      
    }else if(campo === 'year'){
      const selectedYear = (event.target as HTMLSelectElement).value;
      this.auto.year = selectedYear
      // this.getModelo()
    }else{
      const selectedYear = (event.target as HTMLSelectElement).value;
      this.auto.modelo = selectedYear
      this.getYear()
    }
  }

  getYear(){
    this.ppService.getYear(this.auto.marca_slug, this.auto.year).subscribe(
      data => {
        this.years = data.data
        this.yearDisabled = false
      }
    )
  }

  getModelo(){
    this.ppService.getModelos(this.auto.marca_slug).subscribe(
      data => {
        this.modelos = data.data
        this.modelDisabled = false
      }
    )
  }

  marcasFiltradas() {
    const texto = this.proveedorForm.value.filtro.toLowerCase();
    return this.marcas.filter(m => m.name.toLowerCase().includes(texto));
  }
}
